import { render, staticRenderFns } from "./PayrollItem.vue?vue&type=template&id=e169ff90&scoped=true"
import script from "./PayrollItem.vue?vue&type=script&lang=js"
export * from "./PayrollItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e169ff90",
  null
  
)

export default component.exports